


export const renameProps = { class: 'staticClass', scope: 'scopedSlots' }


export const showPlaceholderNode = ['el-input', 'el-autocomplete', 'el-select', 'el-cascader', 'el-time-select', 'el-time-picker', 'el-date-picker']